import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "@/store/store";

export const primaryActiveRoleSelector = createSelector(
    [
        (state: RootState) => {
            return state.user.primaryCombinedRole.children;
        },
        (state: RootState) => {
            return state.user.primaryActiveRoleId;
        },
    ],
    (primaryRoles, primaryActiveRoleId) => {
        return primaryRoles.find((role) => role.id === primaryActiveRoleId);
    },
);
